<template>
  <div class="Menu" id="MENU">
    <b-navbar toggleable="lg" type="dark" variant="info" class="container">
        <b-navbar-brand href='/'>
            <b-img class="logo" src="https://wp-ocssport.ocs-sport.com/ocs-studios/wp-content/uploads/sites/2/2023/09/OCS_Studios_425x425-1.png"></b-img>
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <template v-if="this.$route.name == 'home'">
            <b-navbar-nav class="ml-auto">
                <b-nav-item class="navItems" @click="scroll()">Our Skills</b-nav-item>
                <b-nav-item class="navItems" @click="scrolltwo()">About Us</b-nav-item>
                <b-nav-item class="navItems" to="/blogs">Our Blog</b-nav-item>
                <b-nav-item class="navItems" to="/portfolio">Portfolio</b-nav-item>
                <b-nav-item class="navItems" @click="scrollthree()">
                    <b-button class="getInTouch" variant="danger">Get In Touch</b-button>
                </b-nav-item>
            </b-navbar-nav>
          </template>
          <template v-else>
            <b-navbar-nav class="ml-auto">
                <b-nav-item class="navItems" to="/">Our Skills</b-nav-item>
                <b-nav-item class="navItems" to="/">About Us</b-nav-item>
                <b-nav-item class="navItems" to="/blogs">Our Blog</b-nav-item>
                <b-nav-item class="navItems" to="/portfolio">Portfolio</b-nav-item>
                <b-nav-item class="navItems" to="/">
                    <b-button class="getInTouch" variant="danger">Get In Touch</b-button>
                </b-nav-item>
            </b-navbar-nav>
          </template>
            <b-navbar-brand href='https://ocs-sport.com/#/' target="_blank">
                <b-img class="supportLogos" src="https://wp-ocssport.ocs-sport.com/wp-content/uploads/2023/05/OCS-Sport_white.png"></b-img>
            </b-navbar-brand>
            <b-navbar-brand href='https://ocs-digital.com/' target="_blank">
                <b-img class="supportLogos" src="https://wp-ocssport.ocs-sport.com/wp-content/uploads/2023/05/OCS-Digital_white.png"></b-img>
            </b-navbar-brand>
        </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: 'Menu',
  props: {

  },
  methods: {
    myScrollFuncss: function() {

      this.myScrollFunc = function (myID) {
          myID = document.getElementById("MENU");
          var y = window.scrollY;
          if (y >= 10) {
              myID.className = "bottomMenu show"
          } else {
              myID.className = "bottomMenu hide"
          }
      };

      window.addEventListener("scroll", this.myScrollFunc);
    },
    scroll() {
      var score = document.getElementById("skills");
      score.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    },
    scrolltwo() {
      var score = document.getElementById("about");
      score.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    },
    scrollthree() {
      var score = document.getElementById("contact");
      score.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    },
    scrollfour() {
      var score = document.getElementById("blog");
      score.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    },
  },
  mounted() {
    this.myScrollFuncss()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .Menu {
      display: none;
    }
    .hide {
      opacity:0;
      display: none;
    }
    .show {
      opacity: 1;
      background: #010322;
      position: fixed;
      width: 100%;
      z-index: 999;
    }
    img.supportLogos {
      width: 45px;
    }
    ::v-deep .btn-danger {
      color: #fff;
      background-color: #efd170;
      border-color: #efd170!important;
    }
    .navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {
        color: #7ebd63;
    }
    .navItems {
        /* padding-right: 40px;
        padding-left: 40px; */
        padding-right: 21px;
        padding-left: 21px;
        line-height: 2;
        scroll-behavior: smooth;
        color:#fff;
    }
    .navItems:hover {
        /* padding-right: 30px;
        padding-left: 30px; */
        line-height: 2;
        scroll-behavior: smooth;
        color:rgb(232 63 75);
        text-decoration: none;
    }
    .logo {
        width: 100px;
    }
    .Menu {
        background-color: #000322 !important;
        padding-top: 30px;
        padding-bottom: 30px;
    }
    .bg-info {
        background-color: #000322 !important;
    }
    .navbar-dark .navbar-nav .nav-link {
        color: #fff;
    }
    button.getInTouch {
        background-color: #efd170;
        border-color: #efd170!important;
        border-radius: 0px;
        width: 163px;
        height: 31px;
        line-height: 1;
        color: #010322;
    }
    button.getInTouch:hover {
        background-color: #7ebd63;
        border-color: #7ebd63!important;
        color: #010322;
    }

    @media only screen and (max-width: 500px) {
      img.supportLogos {
          width: 50px;
          margin-top: 15px;
      }
    }
</style>
